import { estimateContextInitialValue } from './estimate.constants';
import { EstimateContextType } from './estimate.types';

import { createTypeSafeContext } from '~/core/utils';

const [useEstimateContext, EstimateContext] =
  createTypeSafeContext<EstimateContextType>(estimateContextInitialValue);

export { EstimateContext, useEstimateContext };
